const eventBus = new Map<string, Set<Function>>();

export const eventsService = {
    on: <L extends Function>(eventName: string, listener: L) => {
        if (eventBus.has(eventName)) {
            eventBus.get(eventName)?.add(listener);
        } else {
            const listenersList = new Set<Function>();
            listenersList.add(listener);
            eventBus.set(eventName, listenersList);
        }
    },
    off: <L extends Function>(eventName: string, listener: L) => {
        if (eventBus.has(eventName)) {
            eventBus.get(eventName)?.delete(listener);
        }
    },
    trigger: (eventName: string, ...params: any[]) => {
        const listeners = eventBus.get(eventName);

        if (listeners) {
            listeners.forEach(listener => listener(...params));
        }
    },
};
